import { LocationState, Payload } from 'redux-first-router'
import { createSelector } from 'reselect'

import { Page } from '~shared-components/utils/enums'

import { asPage } from '../../utils'
import { Locale } from '../../utils/locale/locale'
import { ConfigState } from '../reducers/config.reducers'
import { SharedState } from '../sharedState'

const location = (state: SharedState): LocationState => state.location

const page = <T extends Record<string, string>>(
  pages: T,
  routeMap: Record<string, unknown>,
) =>
  createSelector(
    [location],
    (state): Page => asPage(state.type, pages, routeMap),
  )

const pageType = createSelector([location], state => state.type)

const payload = createSelector([location], (state): Payload => state.payload)
const country = createSelector([payload], state => state.country)

const query = createSelector([location], state => state.query)

const pageNumber = createSelector([location], state =>
  state.query?.page ? parseInt(state.query.page) : undefined,
)

const locale = createSelector<SharedState, ConfigState, Locale | undefined>(
  state => state.config,
  state => state.locale,
)

const selectedId = createSelector(
  [payload],
  (state): string | undefined => state.id,
)

export const LocationSelector = {
  country,
  locale,
  location,
  page,
  pageNumber,
  pageType,
  payload,
  query,
  selectedId,
}
